import { TerminalWebComponent } from './component/TerminalWebComponent';
import { WEB_COMPONENT_TERMINAL } from '../../webcomponents.constants';

export { TerminalWebComponent };

window.customElements.define(WEB_COMPONENT_TERMINAL, TerminalWebComponent);
